import { Box } from '@mui/material';
import Stack from '@mui/material/Stack';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import Tooltip from '@mui/material/Tooltip';
import UpgradeSymbols from './UpgradeSymbols';
import { NumberChip, GreaterThanIcon } from './BookingIcons';

function BookingCardIcons({
  comment,
  upgrades,
  manualUpgrades,
  participantCount,
  slotMode,
  color,
  onGreaterThanClick,
}) {
  return (
    <Stack
      direction='row'
      spacing={1}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {comment && (
          <Tooltip title={comment}>
            {/* Theme-aware color keeps the note icon visible on the light card
                surface in light mode (white-on-white was invisible there). */}
            <TextSnippetIcon sx={{ color: 'text.secondary' }} />
          </Tooltip>
        )}
      </Box>
      <UpgradeSymbols upgrades={upgrades} manualUpgrades={manualUpgrades} />
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <NumberChip number={participantCount} size='small' color={color} />
      </Box>
      {slotMode && (
        <Box
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            onGreaterThanClick(e);
          }}
          onMouseDown={e => {
            // Prevent parent card's mouse down handler from initiating a drag or click
            e.stopPropagation();
          }}
          onTouchStart={e => {
            // Prevent parent card's touch start handler from initiating a drag or click
            e.stopPropagation();
          }}
          onTouchEnd={e => {
            e.preventDefault();
            e.stopPropagation();
            onGreaterThanClick(e);
          }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          <GreaterThanIcon color={color} />
        </Box>
      )}
    </Stack>
  );
}

export default BookingCardIcons;
